import { JumpTarget } from 'config/loanJumpTargets'
import { getAppBorrowerMenu } from 'pages/LoanApplication/logic'

// The loan application's left-nav sections (Borrower Information, Property, Employment, …),
// each deep-linked to that menu via ?menu=<key>.
export const getApplicationMenuTargets = (): JumpTarget[] => {
  let menu: Record<string, string> = {}
  try {
    menu = (getAppBorrowerMenu() as Record<string, string>) || {}
  } catch {
    return []
  }
  return Object.keys(menu)
    .filter((key) => menu[key])
    .map((key) => ({
      id: `appmenu-${key}`,
      label: menu[key],
      group: 'Application',
      keywords: `application menu section ${key}`,
      to: (n) => `/loan_process/application/${n}?menu=${key}`,
    }))
}
